import React from 'react';
import { SimpleShowLayout, TextField, Record, useTranslate } from 'react-admin';
import SectionTitle from '../SectionTitle';

import './styles.scss';

interface TestActivationAnswersProps {
  record: Record | undefined;
}

// Test activation data for Health Check Basic in Nutrition Advice Show view
const TestActivationAnswers: React.FC<TestActivationAnswersProps> = ({
  record,
}) => {
  const translate = useTranslate();
  const dataSource = record?.test ? 'test.answers' : 'answers';

  return (
    <SimpleShowLayout>
      <SectionTitle title={translate('testActivationAnswers.title')} />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.diet`}
        label="testActivationAnswers.question.diet"
        emptyText="-"
      />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.bloodPressureMeasuredValue`}
        label="testActivationAnswers.question.bloodPressureMeasuredValue"
        emptyText="-"
      />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.heartAttackInFamily`}
        label="testActivationAnswers.question.heartAttackInFamily"
        emptyText="-"
      />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.takingMedicationRegularly`}
        label="testActivationAnswers.question.takingMedicationRegularly"
        emptyText="-"
      />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.medicationName`}
        label="testActivationAnswers.question.medicationName"
        emptyText="-"
      />
      <TextField
        className="testActivationAnswers__item"
        source={`${dataSource}.smoking`}
        label="testActivationAnswers.question.smoking"
        emptyText="-"
      />
    </SimpleShowLayout>
  );
};

export default TestActivationAnswers;
